/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DirectoryRoleSetupPreviewItem,
  DirectoryRoleSetupPreviewItem$inboundSchema,
} from "./directoryrolesetuppreviewitem.js";

/**
 * new_group: an unmapped group first seen after review started. new_attribute_value: a new value of an attribute key that has mappings. source_missing: a mapped group or attribute value that has gone.
 */
export const DirectoryReviewItemKind = {
  NewGroup: "new_group",
  NewAttributeValue: "new_attribute_value",
  SourceMissing: "source_missing",
} as const;
/**
 * new_group: an unmapped group first seen after review started. new_attribute_value: a new value of an attribute key that has mappings. source_missing: a mapped group or attribute value that has gone.
 */
export type DirectoryReviewItemKind = ClosedEnum<
  typeof DirectoryReviewItemKind
>;

export type DirectoryReviewItem = {
  /**
   * When the item was raised.
   */
  createdAt: Date;
  /**
   * The review item.
   */
  id: string;
  item: DirectoryRoleSetupPreviewItem;
  /**
   * new_group: an unmapped group first seen after review started. new_attribute_value: a new value of an attribute key that has mappings. source_missing: a mapped group or attribute value that has gone.
   */
  kind: DirectoryReviewItemKind;
  /**
   * 1 the first time a source is raised for this kind, then one more each time it recurs.
   */
  occurrence: number;
};

/** @internal */
export const DirectoryReviewItemKind$inboundSchema: z.ZodMiniEnum<
  typeof DirectoryReviewItemKind
> = z.enum(DirectoryReviewItemKind);

/** @internal */
export const DirectoryReviewItem$inboundSchema: z.ZodMiniType<
  DirectoryReviewItem,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    item: DirectoryRoleSetupPreviewItem$inboundSchema,
    kind: DirectoryReviewItemKind$inboundSchema,
    occurrence: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
    });
  }),
);

export function directoryReviewItemFromJSON(
  jsonString: string,
): SafeParseResult<DirectoryReviewItem, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DirectoryReviewItem$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DirectoryReviewItem' from JSON`,
  );
}
